import { z } from 'my-zod'
import { customerOrderImportantInformationModel } from './customer-order-important-information-model'

export const customerOrderImportantInformationUpdate = customerOrderImportantInformationModel
  .pick({
    outfitterId: true,
    title: true,
    text: true,
    productIds: true
  })
  .extend({
    text: z.string().max(1400).min(1, { message: 'Required' }),
    title: z.string().max(256).min(1, { message: 'Required' })
  })

export type customerOrderImportantInformationUpdate = z.infer<typeof customerOrderImportantInformationUpdate>
